import * as React from 'react';
import {View} from 'react-native';
import {useStyles} from '../../../../../../shared/hooks/styles';
import {Button} from '../../../../../../shared/components/button';
import {ProductCategoryFilterList} from '../../list';
import {ProductsCategoryFilterViewBaseProps} from '../../../model';

export default ({productCategories, onSubmit}: ProductsCategoryFilterViewBaseProps) => {
  const styles = useStyles(() => ({
    container: {
      paddingBottom: 30,
    },
    filterButtonContainer: {},
    filterButton: {},
  }));
  return (
    <View style={styles.container}>
      <ProductCategoryFilterList visuallyImpaired productCategories={productCategories} />
      <View style={[styles.filterButtonContainer]}>
        <Button id='filter-show' text='Показать' type='secondary' style={styles.filterButton} onPress={onSubmit} />
      </View>
    </View>
  );
};
